import React from "react";
import DropdownMenu from "./DropdownMenu";

const MapDisplay = ({
  compareBool,
  lockState,
  setLockState,
  gridModels,
  handleGridModelChange,
  griddedMapRefs,
  disablePopup,
  enablePopup,
}) => {
  return compareBool ? (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", height: "100%" }}>
      {[0, 1, 2, 3].map((index) => (
        <div key={index} id={`map-${index}`} className="comparison-map">
          {index === 0 && (
            <>
              <input
                type="checkbox"
                id="lockViews"
                checked={lockState}
                onChange={() => setLockState(!lockState)}
              />
              <label htmlFor="lockViews" id="lockText">
                Lock Views
              </label>
            </>
          )}
          <DropdownMenu
            label="Select Model"
            selectedValue={gridModels[index]}
            options={[
              { value: "fcnv2_gfs", label: "FourCastNet v2-small" },
              { value: "fcnv2_ifs", label: "FourCastNet v2-small IFS" },
              { value: "pw_gfs", label: "Pangu-Weather" },
              { value: "pw_ifs", label: "Pangu-Weather IFS" },
              { value: "gc_gfs", label: "GraphCast Operational" },
              { value: "gc_ifs", label: "GraphCast Operational IFS" },
              { value: "au_gfs", label: "Aurora" },
              { value: "au_ifs", label: "Aurora IFS" },
              { value: "gfs_gfs", label: "GFS" },
              { value: "ifs_ifs", label: "IFS" },
              { value: "aifs_aifs", label: "AIFS" },
            ]}
            onChange={(e) => handleGridModelChange(e, index, gridModels)}
            onMouseOver={disablePopup}
            onMouseOut={enablePopup}
            className="compareMenu"
          />
        </div>
      ))}
    </div>
  ) : (
    <div id="map" className="single-map" />
  );
};

export default MapDisplay;
